module.exports = __webpack_public_path__ + "img/about_03.534cbf99.jpg";